<template>
  <div style="display: inline-block" class="mr-3 flex-grow-0 flex-shrink-1">
    <v-btn
        color="red"
        dark
        x-small
        fab
        :loading="loading"
        @click="prev"
    >
      <v-icon>undo</v-icon>
    </v-btn>
  </div>
</template>

<script>

import OrderProvider from "@/modules/delivery/providers/OrderProvider";
import {ORDER_STATES} from "@/modules/delivery/constants/OrderStates";
import {TAKE_AWAY} from "@/modules/delivery/constants/OrderDelivery";
import {SALON} from "@/modules/delivery/constants/OrderOrigin";

export default {
  name: "OrderPrevFlowState",
  props: {
    order: {type: Object},
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    getPrevStep() {
      let index = ORDER_STATES.findIndex(state => state === this.order.state)
      if ([TAKE_AWAY, SALON].includes(this.order.delivery.mode) && this.order.state === 'DELIVERED') {
        return ORDER_STATES[index - 2]
      } else if (index > 0) {
        return ORDER_STATES[index - 1]
      }
      return this.order.state
    }
  },
  methods: {
    async prev() {
      try {
        this.loading = true

        let prevState = this.getPrevStep
        if (this.order.delivery.mode === 'DELIVERY' && ['READY', 'PREPARING'].includes(prevState)) {
          await this.clearDeliveryUser()
        }
        await this.updateOrderState(prevState)
        this.order.state = prevState

        this.$emit("orderUpdated", this.order)

      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }


    },
    async updateOrderState(state) {
      return await OrderProvider.updateOrderState({id: this.order.id, state: state})
    },
    async clearDeliveryUser() {
      this.loading = true
      return await OrderProvider.updateOrderDeliveryUser({orderId: this.order.id, userId: null})

    },
  }
}
</script>

<style scoped>

</style>
